<template>
  <v-modal title="" :show="show" @close="$emit('close', flags.reload)" size="lg" buttonClose="true">
    <ui-spinner v-if="loading.view"></ui-spinner>
    <template v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input v-model="name" type="text" class="form-control form-control-sm" />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Teléfono *</label>
            <input v-model="phone" type="text" class="form-control form-control-sm" />
          </div>
          <div class="text-right">
            <button class="btn btn-sm btn-outline-success" :disabled="loading.crud" @click="onNew">
              Nuevo
            </button>
            <button class="ml-2 btn btn-sm btn-primary" :disabled="loading.crud" @click="onSave">
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 80px"></th>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in containers.contactos" :key="item.idAgenciaContacto" class="align-middle text-center">
                  <td>
                    <template v-if="item.origen != 0">
                      <button class="btn btn-xs btn-icon btn-light-warning" @click="onEdit(item)">
                        <span class="fa fa-fw fa-pencil-alt"></span>
                      </button>
                      <button class="btn btn-xs btn-icon btn-light-danger ml-2" @click="onDelete(item)">
                        <span class="fa fa-fw fa-trash-alt"></span>
                      </button>
                    </template>
                  </td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ item.telefono }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
</template>
<script>
const vModal = () => import(/* webpackChunkName: "ui-modal" */ "@/components/vModal");

export default {
  components: {
    vModal,
  },
  props: ["show", "agencia"],
  data() {
    return {
      name: "",
      phone: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        contactos: [],
      },
      flags: {
        reload: false,
      },
    };
  },
  async created() {
    let vm = this;

    let response = await vm.axios.get(`/mantenimiento/agencias/${vm.agencia.idAgencia}/contactos`);
    vm.containers.contactos = response.data.content.contactos;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        name: (vm.name || "").trim(),
        phone: (vm.phone || "").trim(),
        _method: "POST",
      };

      if (!(fd.name && fd.phone)) {
        return vm.$swal.fire("", "Completa los campos obligatorios (*)", "warning");
      }

      vm.loading.crud = true;

      let endpoint = `/mantenimiento/agencias/${vm.agencia.idAgencia}/contactos`;

      if (vm.containers.id) {
        endpoint = `/mantenimiento/agencias/${vm.agencia.idAgencia}/contactos/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            let findRow = vm.containers.contactos.find((item) => item.idAgenciaContacto == vm.containers.id);

            findRow.nombre = fd.name;
            findRow.telefono = fd.phone;
            findRow.usuarioModif = vm.$store.state.user.codigo;
          } else {
            vm.containers.contactos.push({
              nombre: fd.name,
              telefono: fd.phone,
              idAgenciaContacto: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.containers.id = response.data.content.id;
          }

          vm.flags.reload = true;

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      this.name = pItem.nombre;
      this.phone = pItem.telefono;
      this.containers.id = pItem.idAgenciaContacto;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire("", "¿Seguro que desea eliminar este item?");

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/agencias/${vm.agencia.idAgencia}/contactos/${pItem.idAgenciaContacto}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.contactos];
            vm.containers.contactos = tempRegistros.filter((item) => item.idAgenciaContacto != pItem.idAgenciaContacto);
            vm.flags.reload = true;
            vm.onNew();
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.name = "";
      vm.phone = "";
      vm.containers.id = null;
    },
  },
};
</script>
